import React from "react";

const personalInfoContent = [
  { meta: "first name", metaInfo: "Hunter" },
  { meta: "last name", metaInfo: "Gulley" },
  { meta: "Age", metaInfo: "27 Years" },
  { meta: "Nationality", metaInfo: "American" },
  { meta: "Freelance", metaInfo: "Available" },
  { meta: "Locality", metaInfo: "Dayton, OH" },
  { meta: "phone", metaInfo: "+1(937) 234-7257" },
  { meta: "Email", metaInfo: "hgulley@huntergulley.com" },
  { meta: "langages", metaInfo: "English" },
];

const PersonalInfo = () => {
  return (
    <ul className="about-list list-unstyled open-sans-font">
      {personalInfoContent.map((val, i) => (
        <li key={i}>
          <span className="title">{val.meta}: </span>
          <span className="value d-block d-sm-inline-block d-lg-block d-xl-inline-block">
            {val.metaInfo}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default PersonalInfo;
